import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "px-3 pb-8 md:px-0" }
const _hoisted_2 = { class: "mb-4 grid grid-cols-2 gap-3 md:grid-cols-4" }
const _hoisted_3 = { class: "stat-card" }
const _hoisted_4 = { class: "stat-card" }
const _hoisted_5 = { class: "text-red-600" }
const _hoisted_6 = { class: "stat-card" }
const _hoisted_7 = { class: "text-amber-600" }
const _hoisted_8 = { class: "stat-card" }
const _hoisted_9 = { class: "text-blue-600" }
const _hoisted_10 = {
  key: 0,
  class: "py-12 text-center text-black"
}
const _hoisted_11 = {
  key: 1,
  class: "rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700"
}
const _hoisted_12 = {
  key: 2,
  class: "rounded-xl border border-gray-200 bg-white py-12 text-center shadow-sm"
}
const _hoisted_13 = { class: "overflow-x-auto rounded-xl border border-gray-200 bg-white shadow-sm" }
const _hoisted_14 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_15 = { class: "divide-y divide-gray-100" }
const _hoisted_16 = { class: "table-cell font-semibold" }
const _hoisted_17 = { class: "table-cell" }
const _hoisted_18 = { class: "table-cell" }
const _hoisted_19 = { class: "table-cell" }
const _hoisted_20 = { class: "table-cell" }
const _hoisted_21 = { class: "table-cell" }
const _hoisted_22 = { class: "min-w-96 max-w-xl whitespace-normal px-4 py-4 align-top text-sm text-black" }
const _hoisted_23 = { class: "leading-6" }

import { onMounted, ref } from 'vue'
import { PageHeader, UnifiedPagination } from '@/components'
import {
  fetchSellerLitigesRetours,
  fetchSellerLitigeRetourStats,
  type LitigeRetourStats,
  type LitigeRetourStatus,
  type LitigeRetourType,
  type SellerLitigeRetour,
} from '@/api/litigesRetours'


export default /*@__PURE__*/_defineComponent({
  __name: 'MyLitigesRetoursView',
  setup(__props) {

const items = ref<SellerLitigeRetour[]>([])
const total = ref(0)
const page = ref(1)
const limit = ref(10)
const isLoading = ref(false)
const errorMessage = ref('')
const stats = ref<LitigeRetourStats>({
  total: 0,
  ouverts: 0,
  litiges: 0,
  retours: 0,
})

async function loadItems(): Promise<void> {
  isLoading.value = true
  errorMessage.value = ''
  try {
    const [result, statsResult] = await Promise.all([
      fetchSellerLitigesRetours({ page: page.value, limit: limit.value }),
      fetchSellerLitigeRetourStats(),
    ])
    items.value = result.items
    total.value = result.total
    stats.value = statsResult
  } catch (error) {
    errorMessage.value = error instanceof Error ? error.message : 'Impossible de charger les demandes.'
  } finally {
    isLoading.value = false
  }
}

function changePage(value: number): void {
  page.value = value
  void loadItems()
}

function changeLimit(value: number): void {
  page.value = 1
  limit.value = value
  void loadItems()
}

function typeLabel(type: LitigeRetourType): string {
  return type === 'litige' ? 'Litige' : 'Retour'
}

function statusLabel(status: LitigeRetourStatus): string {
  return {
    en_attente: 'En attente',
    en_traitement: 'En traitement',
    resolu: 'Résolu',
    rejete: 'Rejeté',
  }[status]
}

function statusClass(status: LitigeRetourStatus): string[] {
  return [
    'inline-flex rounded-full px-2.5 py-1 text-xs font-semibold',
    {
      en_attente: 'bg-amber-100 text-amber-700',
      en_traitement: 'bg-blue-100 text-blue-700',
      resolu: 'bg-green-100 text-green-700',
      rejete: 'bg-red-100 text-red-700',
    }[status],
  ]
}

function formatDate(value: string | null): string {
  if (!value || value.startsWith('0000-00-00')) return '—'
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? '—' : new Intl.DateTimeFormat('fr-FR').format(date)
}

onMounted(loadItems)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(PageHeader), {
      title: "Mes litiges et retours",
      subtitle: "Consultez les demandes liées à vos commandes.",
      class: "mb-4 pr-10"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("strong", null, _toDisplayString(stats.value.total), 1),
          _cache[0] || (_cache[0] = _createElementVNode("span", null, "Total", -1))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("strong", _hoisted_5, _toDisplayString(stats.value.litiges), 1),
          _cache[1] || (_cache[1] = _createElementVNode("span", null, "Litiges", -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("strong", _hoisted_7, _toDisplayString(stats.value.retours), 1),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Retours", -1))
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("strong", _hoisted_9, _toDisplayString(stats.value.ouverts), 1),
          _cache[3] || (_cache[3] = _createElementVNode("span", null, "Ouverts", -1))
        ])
      ]),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "fas fa-spinner fa-spin text-2xl" }, null, -1),
            _createElementVNode("p", { class: "mt-2" }, "Chargement des demandes...", -1)
          ])))
        : (errorMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(errorMessage.value), 1))
          : (items.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _cache[5] || (_cache[5] = [
                _createElementVNode("i", { class: "fas fa-inbox mb-3 text-4xl text-gray-400" }, null, -1),
                _createElementVNode("p", { class: "text-black" }, "Aucune demande.", -1)
              ])))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("table", _hoisted_14, [
                    _cache[6] || (_cache[6] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "table-heading" }, "N° demande"),
                        _createElementVNode("th", { class: "table-heading" }, "Commande groupe"),
                        _createElementVNode("th", { class: "table-heading" }, "Acheteur"),
                        _createElementVNode("th", { class: "table-heading" }, "Type"),
                        _createElementVNode("th", { class: "table-heading" }, "Statut"),
                        _createElementVNode("th", { class: "table-heading" }, "Date"),
                        _createElementVNode("th", { class: "table-heading" }, "Description")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: item.id,
                          class: "hover:bg-gray-50"
                        }, [
                          _createElementVNode("td", _hoisted_16, "#" + _toDisplayString(item.id), 1),
                          _createElementVNode("td", _hoisted_17, _toDisplayString(item.orderGroupId), 1),
                          _createElementVNode("td", _hoisted_18, _toDisplayString(item.buyerName || '—'), 1),
                          _createElementVNode("td", _hoisted_19, _toDisplayString(typeLabel(item.typeRequest)), 1),
                          _createElementVNode("td", _hoisted_20, [
                            _createElementVNode("span", {
                              class: _normalizeClass(statusClass(item.status))
                            }, _toDisplayString(statusLabel(item.status)), 3)
                          ]),
                          _createElementVNode("td", _hoisted_21, _toDisplayString(formatDate(item.dateCommande)), 1),
                          _createElementVNode("td", _hoisted_22, [
                            _createElementVNode("p", _hoisted_23, _toDisplayString(item.description), 1)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createVNode(_unref(UnifiedPagination), {
                  "current-page": page.value,
                  "total-items": total.value,
                  "items-per-page": limit.value,
                  "items-per-page-options": [10, 25, 50],
                  "item-label": "demandes",
                  "onUpdate:currentPage": changePage,
                  "onUpdate:itemsPerPage": changeLimit
                }, null, 8, ["current-page", "total-items", "items-per-page"])
              ], 64))
    ])
  ], 64))
}
}

})